import { injectGlobal } from 'emotion'
import { Font } from './'

injectGlobal`
  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;

    /*
    @media all and (min-width: 1024px){
      font-size: 1.11vw;
    }

    @media all and (min-width: 1600px) {
      font-size: 16px;
    }
    */
  }

  body {
    font-family: ${ Font.base }, sans-serif;
    margin: 0px;

    overflow-x: hidden;
  }

  * {
    box-sizing: border-box;
  }

  .container {
    width: 100%;
    padding: 0px 40px;
    max-width: 460px;
    margin: 0px auto;
  }

  .flex{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .flex-nowrap{
    flex-wrap: nowrap;
  }

  .items-center{
    align-items: center;
  }

  .content-center{
    justify-content: center;
  }

  .flex-column{
    flex-direction: column;

    .column{
      flex: 1 0 auto;
    }
  }

  p{
    font-size: 1rem;
    line-height: 2em;
    font-family: ${ Font.base };
  }

  *:focus {
    outline: 0;
  }

  a{
    text-decoration: none;
  }

  ul.reset{
    list-style: none;
    margin: 0px;
    padding: 0px;
  }

  img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }

  .fluid{
    width: 100%;
    padding: 0px 20px;
  }

  .btn-reset{
    background: none;
    margin: 0px;
    border: 0px;
  }

  .page-inner{
    padding: 20px;
  }

  .content b, .content strong{
    font-weight: bold;
  }

  .content a {
    border-bottom: 1px solid black;
    color: black;
  }

  .content ul,
  .content ol {
    text-align: left;
    padding: 0px 1rem;
  }
  
  .content ol {
    counter-reset: item;
    list-style: none;
    
  }

  .content ol > li{
    counter-increment: item;
    padding-left: 1.5rem;
    position: relative;
  }

  ol > li:before {
    display: inline-block;
    width: 1em;
    font-weight: bold;
    content: counter(item) ".";
    position: absolute;
    top: 8px;
    left: 0;
  }

  .content li {
    padding: 0.5rem 0;
  }

  .content b, .content strong{
    font-weight: bold;
  }

  .transition{
    transition: all 1000ms ease 400ms;
    opacity: 0;
    transform: translateY(10px);
  }

  .transition--ready{
    opacity: 1;
    transform: translateY(0px);
  }

  @media (min-width: 768px){
    .fluid{
      padding: 0px 4rem;
    }

    .page-inner{
      padding: 4rem;
    }
  }

  @media (min-width: 1024px){
    .fluid{
      padding: 0px 8rem;
    }

    .page-inner{
      padding: 4rem 8rem;
    }
  }

  @media print {
    header, footer, .no-print{
      display: none;
    }
  }
`


// WEBPACK FOOTER //
// ./src/styles/global.js